"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreeContext = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
exports.TreeContext = react_1.default.createContext({
    selectable: false,
    activable: false,
    expandedIds: [],
    activeIds: [],
    fullExpandable: false,
    fullActivable: false,
});
//# sourceMappingURL=TreeContext.js.map